<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="dash-trucks-top1">
      <a
        [ngClass]="{ active: tripType == '-1' }"
        (click)="getTripsList('-1')"
        (click)="tripsStatus('success')"
        >Successfull</a
      >
      <a
        [ngClass]="{ active: tripType == 'liveTrips' }"
        (click)="getTripsList('liveTrips')"
        (click)="tripsStatus('failure')"
        >Failed</a
      >
    </div>
    <div class="dash-trucks-top2" *ngIf="!failed">
      <input
        appAlphanumericOnly
        toUppercase
        type="text"
        placeholder="Search Trip ID"
        id="searchtripID"
        #newItem
        (keyup)="onInputChange(newItem)"
        (keyup.enter)="isInputValid && search(newItem.value)"
      />
      <button
        (click)="search(newItem.value)"
        *ngIf="search_btn"
        class="margin"
        [disabled]="!isInputValid"
      >
        <img src="../../../assets/img/search-color.svg" />
      </button>
      <button *ngIf="clear_btn" (click)="resetSearch()">
        <img src="../../../assets/img/x-cross-color.svg" />
      </button>
    </div>
  </div>

  <div class="trucks" *ngIf="success">
    <div [class.spinner]="loading"></div>

    <div
      class="row to_container"
      *ngIf="!successtripsArray?.length && !loading"
    >
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="row gy-4">
      <div
        class="col-sm-3"
        *ngFor="let items of successtripsArray; let i = index"
      >
        <div class="truckscol">
          <div class="d-flex justify-content-between align-items-center">
            <p class="ticket fw-bold">
              {{ items.tripInfo[0]?.trip_id || items.tripInfo?.trip_id }}
            </p>
            <a class="notes" (click)="addNotes(items._id)">Add Notes</a>
          </div>
          <div class="payment-container">
            <div class="location-payment">
              <img src="../../../assets/img/location-payment.svg" alt="" />
              <span class="places">
                <span>{{
                  items.tripInfo[0]?.pickup_details?.from_city_name ||
                    items.tripInfo?.pickup_details?.from_city_name
                }}</span>
                <span>{{
                  items.tripInfo[0]?.dropoff_details?.to_city_name ||
                    items.tripInfo?.dropoff_details?.to_city_name
                }}</span>
              </span>
            </div>
            <div class="payment mb-2">
              <div class="amount">Total Amount</div>
              <div class="amount fw-bold d-flex flex-col">
                ₹ {{ items.price_details?.total_amount }} /-
                <span class="tax">( Inc.Taxes )</span>
              </div>
            </div>
          </div>
          <div *ngIf="items.payment_status == 'partial-paid'">
            <p class="truck-number">ID: {{ items.payment_id }}</p>
            <p class="truck-date" style="font-weight: 225">
              RazorPay ID:
              {{
                items.price_details?.payment_history[1]?.razor_payment_response
                  ?.success?.razorpay_payment_id
              }}
            </p>
            <p class="truck-date">
              Actual Amount:
              {{ items.price_details?.actual_price }}
            </p>

            <p class="truck-date">
              Received Amount:{{ items.price_details?.amount_paid }}
            </p>
            <p class="truck-date payment_status">
              Payment Status: {{ items.payment_status }}
            </p>
            <p class="truck-date payment_status">
              Trip Status:
              {{
                items.tripInfo[0]?.trip_status || items.tripInfo?.trip_status
              }}
            </p>
            <p class="truck-date">
              Payment on:
              {{
                items.price_details?.payment_history[1]?.amount_paid_date
                  | date : "dd-MM-yyyy"
              }}
            </p>
            <p class="truck-date">
              at
              {{
                items.price_details?.payment_history[1]?.amount_paid_date
                  | date : "HH:mm a"
              }}
            </p>
          </div>

          <div *ngIf="items.payment_status == 'fully-paid'">
            <p class="truck-number">ID: {{ items.payment_id }}</p>
            <p class="truck-date" style="font-weight: 225">
              RazorPay ID:
              {{
                items.price_details?.payment_history[2]?.razor_payment_response
                  ?.success?.razorpay_payment_id
              }}
            </p>
            <p class="truck-date">
              Actual Amount:
              {{ items.price_details?.actual_price }}
            </p>

            <p class="truck-date">
              Received Amount:{{ items.price_details?.total_amount }}
            </p>
            <p class="truck-date payment_status">
              Payment Status: {{ items.payment_status }}
            </p>
            <p class="truck-date payment_status">
              Trip Status:
              {{
                items.tripInfo[0]?.trip_status || items.tripInfo?.trip_status
              }}
            </p>
            <p class="truck-date">
              Payment on:
              {{
                items.price_details?.payment_history[2]?.amount_paid_date
                  | date : "dd-MM-yyyy"
              }}
            </p>
            <p class="truck-date">
              at
              {{
                items.price_details?.payment_history[2]?.amount_paid_date
                  | date : "HH:mm a"
              }}
            </p>
          </div>
          <div class="row paymentsBtn">
            <div>Success</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('-1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('first')"
      >
        <img
          src="../../../assets/img/pagination-left.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('last')"
      >
        <img
          src="../../../assets/img/pagination-right.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>

  <!------------------------------ Failed Payments ------------------------------>

  <div class="trucks" *ngIf="failed">
    <div [class.spinner]="loading"></div>

    <div class="row to_container">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
  </div>
</div>
